// 订单搜索状态
export const ORDER_STATUS = {
  UNPAYED: 1, // 待支付
  WAITDELIVER: 2, // 待配送
  DELIVERING: 3, // 配送中
  RECEIVED: 4, //  配送完成
  CANCELLED: 5, // 已关闭
  UNAUDITED: 6, //  待开户
  REFUNDED: 7, // 已退款
  PREDELIVERY: 8, // 待开单
  REFUNDEDING: 9 // 退款中
};

export const orderQueryStatus = [
  {
    label: '待支付',
    value: ORDER_STATUS.UNPAYED
  },
  {
    label: '待配送',
    value: ORDER_STATUS.WAITDELIVER
  },
  {
    label: '配送中',
    value: ORDER_STATUS.DELIVERING
  },
  {
    label: '已完成',
    value: ORDER_STATUS.RECEIVED
  },
  {
    label: '已关闭',
    value: ORDER_STATUS.CANCELLED
  },
  {
    label: '待开户',
    value: ORDER_STATUS.UNAUDITED
  },
  {
    label: '已退款',
    value: ORDER_STATUS.REFUNDED
  },
  {
    label: '待开单',
    value: ORDER_STATUS.PREDELIVERY
  },
  {
    label: '退款中',
    value: ORDER_STATUS.REFUNDEDING
  }
];
